

















import { SubscribedPaidMembershipPlan } from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { DateFormat } from '@/util/format'
import BaseState from '@spa/components/pages/paid-membership/unsubscribe/state/BaseState.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: { BaseState },
})
export default class CompleteUnsubscribe extends Vue {
  @Prop({ required: true })
  readonly plan: SubscribedPaidMembershipPlan

  @Prop({ required: true })
  readonly lastActiveDate: Date

  readonly formatDate = DateFormat.yyyyMmDd
}
